export const FETCH_ROLE_CONFIGS = 'USERROLE/FETCH_ROLE_CONFIGS';
export const FETCH_ROLE_CONFIGS_SUCCESS = 'USERROLE/FETCH_ROLE_CONFIGS_SUCCESS';
export const FETCH_ROLE_CONFIGS_FAILURE = 'USERROLE/FETCH_ROLE_CONFIGS_FAILURE';

export const SET_LOCAL_PERMISSION = 'USERROLE/SET_LOCAL_PERMISSION'; // UI-only update (optimistic)
export const UPDATE_ROLE_CONFIG = 'USERROLE/UPDATE_ROLE_CONFIG'; // persist to server
export const UPDATE_ROLE_CONFIG_SUCCESS = 'USERROLE/UPDATE_ROLE_CONFIG_SUCCESS';
export const UPDATE_ROLE_CONFIG_FAILURE = 'USERROLE/UPDATE_ROLE_CONFIG_FAILURE';

export const FETCH_ROLES = 'USERROLE/FETCH_ROLES';
export const FETCH_ROLES_SUCCESS = 'USERROLE/FETCH_ROLES_SUCCESS';
export const FETCH_ROLES_FAILURE = 'USERROLE/FETCH_ROLES_FAILURE';

export const FETCH_PERMISSIONS_LIST = 'USERROLE/FETCH_PERMISSIONS_LIST';
export const FETCH_PERMISSIONS_LIST_SUCCESS = 'USERROLE/FETCH_PERMISSIONS_LIST_SUCCESS';
export const FETCH_PERMISSIONS_LIST_FAILURE = 'USERROLE/FETCH_PERMISSIONS_LIST_FAILURE';

export const FETCH_ROLE_PERMISSIONS = 'USERROLE/FETCH_ROLE_PERMISSIONS';
export const FETCH_ROLE_PERMISSIONS_SUCCESS = 'USERROLE/FETCH_ROLE_PERMISSIONS_SUCCESS';
export const FETCH_ROLE_PERMISSIONS_FAILURE = 'USERROLE/FETCH_ROLE_PERMISSIONS_FAILURE';

export const FETCH_ROLE_USERS = 'USERROLE/FETCH_ROLE_USERS';
export const FETCH_ROLE_USERS_SUCCESS = 'USERROLE/FETCH_ROLE_USERS_SUCCESS';
export const FETCH_ROLE_USERS_FAILURE = 'USERROLE/FETCH_ROLE_USERS_FAILURE';

export const UPDATE_ROLE_PERMISSIONS = 'USERROLE/UPDATE_ROLE_PERMISSIONS';
export const UPDATE_ROLE_PERMISSIONS_SUCCESS = 'USERROLE/UPDATE_ROLE_PERMISSIONS_SUCCESS';
export const UPDATE_ROLE_PERMISSIONS_FAILURE = 'USERROLE/UPDATE_ROLE_PERMISSIONS_FAILURE';

export const UPDATE_ROLE_USERS = 'USERROLE/UPDATE_ROLE_USERS';
export const UPDATE_ROLE_USERS_SUCCESS = 'USERROLE/UPDATE_ROLE_USERS_SUCCESS';
export const UPDATE_ROLE_USERS_FAILURE = 'USERROLE/UPDATE_ROLE_USERS_FAILURE';

export const MAP_ROLE_PERMISSION = 'USERROLE/MAP_ROLE_PERMISSION';
export const MAP_ROLE_PERMISSION_SUCCESS = 'USERROLE/MAP_ROLE_PERMISSION_SUCCESS';
export const MAP_ROLE_PERMISSION_FAILURE = 'USERROLE/MAP_ROLE_PERMISSION_FAILURE';

export const UNMAP_ROLE_PERMISSION = 'USERROLE/UNMAP_ROLE_PERMISSION';
export const UNMAP_ROLE_PERMISSION_SUCCESS = 'USERROLE/UNMAP_ROLE_PERMISSION_SUCCESS';
export const UNMAP_ROLE_PERMISSION_FAILURE = 'USERROLE/UNMAP_ROLE_PERMISSION_FAILURE';

export const MAP_ROLE_USER = 'USERROLE/MAP_ROLE_USER';
export const MAP_ROLE_USER_SUCCESS = 'USERROLE/MAP_ROLE_USER_SUCCESS';
export const MAP_ROLE_USER_FAILURE = 'USERROLE/MAP_ROLE_USER_FAILURE';

export const UNMAP_ROLE_USER = 'USERROLE/UNMAP_ROLE_USER';
export const UNMAP_ROLE_USER_SUCCESS = 'USERROLE/UNMAP_ROLE_USER_SUCCESS';
export const UNMAP_ROLE_USER_FAILURE = 'USERROLE/UNMAP_ROLE_USER_FAILURE';

export const MAP_ROLE_ADUSER = 'USERROLE/MAP_ROLE_ADUSER';
export const MAP_ROLE_ADUSER_SUCCESS = 'USERROLE/MAP_ROLE_ADUSER_SUCCESS';
export const MAP_ROLE_ADUSER_FAILURE = 'USERROLE/MAP_ROLE_ADUSER_FAILURE';

export const UNMAP_ROLE_ADUSER = 'USERROLE/UNMAP_ROLE_ADUSER';
export const UNMAP_ROLE_ADUSER_SUCCESS = 'USERROLE/UNMAP_ROLE_ADUSER_SUCCESS';
export const UNMAP_ROLE_ADUSER_FAILURE = 'USERROLE/UNMAP_ROLE_ADUSER_FAILURE';

export const ADD_ROLE = 'USERROLE/ADD_ROLE';
export const ADD_ROLE_SUCCESS = 'USERROLE/ADD_ROLE_SUCCESS';
export const ADD_ROLE_FAILURE = 'USERROLE/ADD_ROLE_FAILURE';

export const FETCH_PERMISSION_MAPPINGS = 'USERROLE/FETCH_PERMISSION_MAPPINGS';
export const FETCH_PERMISSION_MAPPINGS_SUCCESS = 'USERROLE/FETCH_PERMISSION_MAPPINGS_SUCCESS';
export const FETCH_PERMISSION_MAPPINGS_FAILURE = 'USERROLE/FETCH_PERMISSION_MAPPINGS_FAILURE';

// action creators
export const fetchRoleConfigs = () => ({ type: FETCH_ROLE_CONFIGS });
export const fetchRoleConfigsSuccess = (payload: any[]) => ({ type: FETCH_ROLE_CONFIGS_SUCCESS, payload });
export const fetchRoleConfigsFailure = (error: any) => ({ type: FETCH_ROLE_CONFIGS_FAILURE, payload: error });

/**
 * payload:
 * {
 *   roleId: number,
 *   category: 'Menus' | 'Tabs' | 'Features',
 *   itemKey: string,
 *   permissionKey?: 'CanRead' | 'CanWrite', // for Tabs/Features items
 *   value: boolean
 * }
 */
export const setLocalPermission = (payload: any) => ({ type: SET_LOCAL_PERMISSION, payload });

export const updateRoleConfig = (roleId: number, body: any) => ({
  type: UPDATE_ROLE_CONFIG,
  payload: { roleId, body },
});
export const updateRoleConfigSuccess = (payload: any) => ({ type: UPDATE_ROLE_CONFIG_SUCCESS, payload });
export const updateRoleConfigFailure = (error: any) => ({ type: UPDATE_ROLE_CONFIG_FAILURE, payload: error });

export const fetchRoles = () => ({ type: FETCH_ROLES });
export const fetchRolesSuccess = (payload: any[]) => ({ type: FETCH_ROLES_SUCCESS, payload });
export const fetchRolesFailure = (err: any) => ({ type: FETCH_ROLES_FAILURE, payload: err });

export const fetchPermissionsList = () => ({ type: FETCH_PERMISSIONS_LIST });
export const fetchPermissionsListSuccess = (payload: any[]) => ({ type: FETCH_PERMISSIONS_LIST_SUCCESS, payload });
export const fetchPermissionsListFailure = (err: any) => ({ type: FETCH_PERMISSIONS_LIST_FAILURE, payload: err });

export const fetchRolePermissions = (roleId: number) => ({ type: FETCH_ROLE_PERMISSIONS, payload: roleId });
export const fetchRolePermissionsSuccess = (roleId: number, payload: any[]) => ({
  type: FETCH_ROLE_PERMISSIONS_SUCCESS,
  payload: { roleId, items: payload },
});
export const fetchRolePermissionsFailure = (err: any) => ({ type: FETCH_ROLE_PERMISSIONS_FAILURE, payload: err });

export const fetchRoleUsers = (roleId: number) => ({ type: FETCH_ROLE_USERS, payload: roleId });
export const fetchRoleUsersSuccess = (roleId: number, payload: any[]) => ({
  type: FETCH_ROLE_USERS_SUCCESS,
  payload: { roleId, users: payload },
});
export const fetchRoleUsersFailure = (err: any) => ({ type: FETCH_ROLE_USERS_FAILURE, payload: err });

export const updateRolePermissions = (roleId: number, permissionIds: number[]) => ({
  type: UPDATE_ROLE_PERMISSIONS,
  payload: { roleId, permissionIds },
});
export const updateRolePermissionsSuccess = (roleId: number, payload: any[]) => ({
  type: UPDATE_ROLE_PERMISSIONS_SUCCESS,
  payload: { roleId, items: payload },
});
export const updateRolePermissionsFailure = (err: any) => ({ type: UPDATE_ROLE_PERMISSIONS_FAILURE, payload: err });

export const updateRoleUsers = (roleId: number, userIds: string[]) => ({
  type: UPDATE_ROLE_USERS,
  payload: { roleId, userIds },
});
export const updateRoleUsersSuccess = (roleId: number, payload: any[]) => ({
  type: UPDATE_ROLE_USERS_SUCCESS,
  payload: { roleId, users: payload },
});
export const updateRoleUsersFailure = (err: any) => ({ type: UPDATE_ROLE_USERS_FAILURE, payload: err });

export const mapRolePermission = (userRoleId: number, permissionId: number) => ({
  type: MAP_ROLE_PERMISSION,
  payload: { userRoleId, permissionId },
});
export const mapRolePermissionSuccess = (userRoleId: number, permissionId: number) => ({
  type: MAP_ROLE_PERMISSION_SUCCESS,
  payload: { userRoleId, permissionId },
});
export const mapRolePermissionFailure = (err: any) => ({ type: MAP_ROLE_PERMISSION_FAILURE, payload: err });

export const unmapRolePermission = (userRoleId: number, permissionId: number) => ({
  type: UNMAP_ROLE_PERMISSION,
  payload: { userRoleId, permissionId },
});
export const unmapRolePermissionSuccess = (userRoleId: number, permissionId: number) => ({
  type: UNMAP_ROLE_PERMISSION_SUCCESS,
  payload: { userRoleId, permissionId },
});
export const unmapRolePermissionFailure = (err: any) => ({ type: UNMAP_ROLE_PERMISSION_FAILURE, payload: err });

export const mapRoleUser = (userRoleId: number, userId: string) => ({
  type: MAP_ROLE_USER,
  payload: { userRoleId, userId },
});
export const mapRoleUserSuccess = (userRoleId: number, userId: string) => ({
  type: MAP_ROLE_USER_SUCCESS,
  payload: { userRoleId, userId },
});
export const mapRoleUserFailure = (err: any) => ({ type: MAP_ROLE_USER_FAILURE, payload: err });

export const unmapRoleUser = (userRoleId: number, userId: string) => ({
  type: UNMAP_ROLE_USER,
  payload: { userRoleId, userId },
});
export const unmapRoleUserSuccess = (userRoleId: number, userId: string) => ({
  type: UNMAP_ROLE_USER_SUCCESS,
  payload: { userRoleId, userId },
});
export const unmapRoleUserFailure = (err: any) => ({ type: UNMAP_ROLE_USER_FAILURE, payload: err });

export const mapRoleAdUser = (userRoleId: number, adUserId: string) => ({
  type: MAP_ROLE_ADUSER,
  payload: { userRoleId, adUserId },
});
export const mapRoleAdUserSuccess = (userRoleId: number, adUserId: string) => ({
  type: MAP_ROLE_ADUSER_SUCCESS,
  payload: { userRoleId, adUserId },
});
export const mapRoleAdUserFailure = (err: any) => ({ type: MAP_ROLE_ADUSER_FAILURE, payload: err });

export const unmapRoleAdUser = (userRoleId: number, adUserId: string) => ({
  type: UNMAP_ROLE_ADUSER,
  payload: { userRoleId, adUserId },
});
export const unmapRoleAdUserSuccess = (userRoleId: number, adUserId: string) => ({
  type: UNMAP_ROLE_ADUSER_SUCCESS,
  payload: { userRoleId, adUserId },
});
export const unmapRoleAdUserFailure = (err: any) => ({ type: UNMAP_ROLE_ADUSER_FAILURE, payload: err });

export const addRole = (body: any) => ({ type: ADD_ROLE, payload: body });
export const addRoleSuccess = (payload: any) => ({ type: ADD_ROLE_SUCCESS, payload });
export const addRoleFailure = (err: any) => ({ type: ADD_ROLE_FAILURE, payload: err });

// permission mappings (roles + users) for a given permission id
export const fetchPermissionMappings = (permissionId: number) => ({
  type: FETCH_PERMISSION_MAPPINGS,
  payload: permissionId,
});
export const fetchPermissionMappingsSuccess = (permissionId: number, payload: any) => ({
  type: FETCH_PERMISSION_MAPPINGS_SUCCESS,
  payload: { permissionId, items: payload },
});
export const fetchPermissionMappingsFailure = (err: any) => ({ type: FETCH_PERMISSION_MAPPINGS_FAILURE, payload: err });
